/**
 * Constantes de integración Flexy Stock (sin variables de entorno)
 */
import { flexyAlmacenes } from '../assets/data/arrays'
import type { FlexyWarehouseDetail } from '../types/cron/flexyStock'

export const DEFAULT_FLEXY_IDEMPRESA = 1

export const FLEXY_STOCK_CRON_PATTERN = '*/30 * * * *'

export const FLEXY_ACTIVE_WAREHOUSES: FlexyWarehouseDetail[] = flexyAlmacenes.map(
  (warehouse) => ({
    idalmacen: warehouse.idalmacen,
    codigo: warehouse.codigo,
    nombre: warehouse.nombre,
    orden_pedido: warehouse.orden_pedido
  })
)

export const FLEXY_STOCK_STATUS_POLL_MS = 5000
